import DonutChart from './DonutChart';
import type { DonutChartDataTypes, DonutChartProps } from './DonutChart.types';

export type { DonutChartDataTypes, DonutChartProps };
export { DonutChart };
export default DonutChart;
